import { page as pageIndex, globals } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
import { logOut } from './auth'
import { showModal, hideModal } from './modal'
import { sortAlphabetical, sortByDate } from './helpers'
// ------------------------------------
// Constants
// ------------------------------------
export const RESET_NEW_MODAL_CONTENT = 'RESET_NEW_MODAL_CONTENT'
export const SET_EDIT_MODAL_CONTENT = 'SET_EDIT_MODAL_CONTENT'
export const GET_MEETINGS_HISTORY_START = 'GET_MEETINGS_HISTORY_START'
export const GET_MEETINGS_HISTORY_FAILURE = 'GET_MEETINGS_HISTORY_FAILURE'
export const GET_MEETINGS_HISTORY_SUCCESS = 'GET_MEETINGS_HISTORY_SUCCESS'
export const GET_MEETING_RECORDS_START = 'GET_MEETING_RECORDS_START'
export const GET_MEETING_RECORDS_FAILURE = 'GET_MEETING_RECORDS_FAILURE'
export const GET_MEETING_RECORDS_SUCCESS = 'GET_MEETING_RECORDS_SUCCESS'
export const DELETE_MEETING_RECORD_START = 'DELETE_MEETING_RECORD_START'
export const DELETE_MEETING_RECORD_SUCCESS = 'DELETE_MEETING_RECORD_SUCCESS'
export const DELETE_MEETING_RECORD_FAILURE = 'DELETE_MEETING_RECORD_FAILURE'
export const SORT_BY_ASSOCIATION = 'SORT_BY_ASSOCIATION'
export const SORT_BY_START_DATE = 'SORT_BY_START_DATE'
export const SORT_MEETINGS_START = 'SORT_MEETINGS_START'
export const RESET_SEARCH_OPTIONS = 'RESET_SEARCH_OPTIONS'
export const CREATE_MEETING_RECORD_START = 'CREATE_MEETING_RECORD_START'
export const CREATE_MEETING_RECORD_FAILURE = 'CREATE_MEETING_RECORD_FAILURE'
export const CREATE_MEETING_RECORD_SUCCESS = 'CREATE_MEETING_RECORD_SUCCESS'
export const UPDATE_MEETING_RECORD_START = 'UPDATE_MEETING_RECORD_START'
export const UPDATE_MEETING_RECORD_FAILURE = 'UPDATE_MEETING_RECORD_FAILURE'
export const UPDATE_MEETING_RECORD_SUCCESS = 'UPDATE_MEETING_RECORD_SUCCESS'
// ------------------------------------
// Actions
// ------------------------------------
export function setResetMeetingModal (meetingObj) {
  if (meetingObj) {
    return {
      type: SET_EDIT_MODAL_CONTENT,
      meetingObj
    }
  } else {
    return {
      type: RESET_NEW_MODAL_CONTENT
    }
  }
}

const headers = {
  'Content-Type': 'application/json'
}

export function getAgencyHistory (searchOptions) {
  return (dispatch) => {
    dispatch({ type: GET_MEETINGS_HISTORY_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    const setSearchOptions = searchOptions ? `?search=${searchOptions.split(' ').join('*')}` : ''
    fetch(`${globals.apiUrl}/meetingdatehistory${setSearchOptions}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: GET_MEETINGS_HISTORY_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_MEETINGS_HISTORY_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_MEETINGS_HISTORY_FAILURE, json: err })
    })
  }
}

export function getMeetingRecords (searchOptions) {
  return (dispatch) => {
    dispatch({ type: GET_MEETING_RECORDS_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    const setSearchOptions = searchOptions || ''
    fetch(`${globals.apiUrl}/meetingdate${setSearchOptions}`, options).then((response) => {
      console.log(setSearchOptions);
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: GET_MEETING_RECORDS_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_MEETING_RECORDS_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_MEETING_RECORDS_FAILURE, json: err })
    })
  }
}

export function deleteMeetingRecord (id) {
  return (dispatch) => {
    dispatch({ type: DELETE_MEETING_RECORD_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/meetingdate/${id}`, options).then((response) => {
      if (response.status === 200) {
        return response.text()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: DELETE_MEETING_RECORD_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then(() => {
        dispatch({
          type: DELETE_MEETING_RECORD_SUCCESS,
          id
        })
        dispatch(hideModal('Delete-meeting'))
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_MEETING_RECORD_FAILURE, json: err })
    })
  }
}

export function sortMeetingRecords (option, isAlphabetically) {
  return (dispatch) => {
    dispatch({ type: SORT_MEETINGS_START })
    setTimeout(function () {
      if (option === 'association') {
        dispatch({
          type: SORT_BY_ASSOCIATION,
          sortOrder: isAlphabetically
        })
      } else if (option === 'date') {
        dispatch({
          type: SORT_BY_START_DATE,
          sortOrder: isAlphabetically
        })
      }
    }),
    2000
  }
}

export function resetOptions () {
  return {
    type: RESET_SEARCH_OPTIONS
  }
}

export function createMeetingRecord (meetingInfo) {
  return (dispatch) => {
    dispatch({ type: CREATE_MEETING_RECORD_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(meetingInfo)
    }
    fetch(`${globals.apiUrl}/meetingdate`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: CREATE_MEETING_RECORD_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        if (json.Message) {
          dispatch({ type: CREATE_MEETING_RECORD_FAILURE, json: json.Message })
          dispatch(showModal('Error'))
        } else {
          dispatch({
            type: CREATE_MEETING_RECORD_SUCCESS,
            meetingInfo: json
          })
          dispatch(hideModal('Add-new-item-meeting'))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_MEETING_RECORD_FAILURE, json: err })
    })
  }
}

const capitalize = (string) => {
  return string.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase() })
}

export function updateMeetingRecord (meetingInfo) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MEETING_RECORD_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(meetingInfo)
    }
    fetch(`${globals.apiUrl}/meetingdate`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: UPDATE_MEETING_RECORD_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        if (json.Message) {
          dispatch({ type: UPDATE_MEETING_RECORD_FAILURE, json: json.Message })
          dispatch(showModal('Error'))
        } else {
          dispatch({
            type: UPDATE_MEETING_RECORD_SUCCESS,
            meetingInfo: json
          })
          dispatch(hideModal('Edit-item-meeting'))
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: UPDATE_MEETING_RECORD_FAILURE, json: err })
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.meetingDates
  ? state : actionHandler(state, action),
  [SET_EDIT_MODAL_CONTENT] : (state, action) => {
    const { Association, Meeting, WebSite, ContactNumber, Location, StartDate, EndDate } = action.meetingObj
    return {
      ...state,
      formDataValue: {
        MD: {
          ...state.formDataValue.MD,
          meetingModal: {
            textValues: {
              association: Association,
              meeting: Meeting,
              website: WebSite,
              contact: ContactNumber,
              location: Location
            },
            dateTime: {
              startDate: StartDate,
              endDate: EndDate
            }
          }
        }
      }
    }
  },
  [RESET_NEW_MODAL_CONTENT] : (state) => {
    return {
      ...state,
      formDataValue: {
        MD: {
          ...state.formDataValue.MD,
          meetingModal: initialState.formDataValue.MD.meetingModal
        }
      }
    }
  },
  [GET_MEETINGS_HISTORY_START] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        history: undefined
      }
    }
  },
  [GET_MEETINGS_HISTORY_SUCCESS] : (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        history: action.payload.json
      }
    }
  },
  [GET_MEETINGS_HISTORY_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [GET_MEETING_RECORDS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_MEETING_RECORDS_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [GET_MEETING_RECORDS_SUCCESS] : (state, action) => {
    const { json } = action.payload
    const associations = json.map(item => capitalize(item.Association).trim())
    const associationslist = [...new Set(associations)].map(item => {
      return { label: item, value: item }
    })
    const query = state.formDataValue.MD.queryLine.radio.query === 0
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        meetingRecords: sortByDate(json, 'StartDate'),
        associationsList: sortAlphabetical(associationslist, 'label'),
        allAssociations: query ? sortAlphabetical(associationslist, 'label') : state.renderData.allAssociations
      }
    }
  },
  [DELETE_MEETING_RECORD_START] : (state) => {
    return {
      ...state
    }
  },
  [DELETE_MEETING_RECORD_SUCCESS] : (state, action) => {
    const { id } = action
    return {
      ...state,
      renderData: {
        ...state.renderData,
        meetingRecords: state.renderData.meetingRecords.filter(item => item.Id !== id)
      }
    }
  },
  [DELETE_MEETING_RECORD_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [SORT_MEETINGS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true,
      renderData: {
        ...state.renderData,
        beforeSortRecords: state.renderData.meetingRecords,
        meetingRecords: []
      }
    }
  },
  [SORT_BY_ASSOCIATION] : (state, action) => {
    const { sortOrder } = action
    const transformRecords = state.renderData.beforeSortRecords.map(item => {
      item.association = capitalize(item.Association)
      return item
    })
    const sortedRecords = sortAlphabetical(transformRecords, 'association')
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        sortApplied: sortOrder,
        meetingRecords: sortOrder ? sortedRecords : sortedRecords.reverse()
      }
    }
  },
  [SORT_BY_START_DATE] : (state, action) => {
    const { sortOrder } = action
    const sortedRecords = sortByDate(state.renderData.beforeSortRecords, 'StartDate')
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        sortApplied: sortOrder,
        meetingRecords: sortOrder ? sortedRecords : sortedRecords.reverse()
      }
    }
  },
  [RESET_SEARCH_OPTIONS] : (state) => {
    return {
      ...state,
      formDataValue: {
        MD: {
          ...state.formDataValue.MD,
          queryLine: {
            radio: {
              ...initialState.formDataValue.MD.queryLine.radio,
              query: state.formDataValue.MD.queryLine.radio.query
            }
          },
          parametersSection: {
            textValues: {},
            dateTime: {
              'Start Date': ' ',
              'End Date': ' '
            },
            radio: {
              Association: ''
            }
          }
        }
      }
    }
  },
  [CREATE_MEETING_RECORD_START] : (state) => {
    return {
      ...state
    }
  },
  [CREATE_MEETING_RECORD_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [CREATE_MEETING_RECORD_SUCCESS] : (state, action) => {
    const { meetingInfo } = action
    let newRecords = state.renderData.meetingRecords
    let associationsList = state.renderData.allAssociations
    const sort = state.formDataValue.MD.queryLine.radio.sort === 'date'
    const query = state.formDataValue.MD.queryLine.radio.query
    if (query === 0) {
      newRecords = [...state.renderData.meetingRecords, meetingInfo]
      newRecords = state.renderData.sortApplied ? newRecords : newRecords.reverse()
    } else if (query === 'association') {
      const checkAssociation = state.formDataValue.MD.parametersSection.radio.Association
      if (meetingInfo.Association.toLowerCase() === checkAssociation.toLowerCase()) {
        newRecords = [...state.renderData.meetingRecords, meetingInfo]
      }
    } else {
      const checkStart = state.formDataValue.MD.parametersSection.dateTime['Start Date']
      const checkEnd = state.formDataValue.MD.parametersSection.dateTime['End Date']
      if (new Date(checkStart) < new Date(meetingInfo.StartDate) &&
        new Date(meetingInfo.StartDate) < new Date(checkEnd)) {
        newRecords = [...state.renderData.meetingRecords, meetingInfo]
      }
    }
    newRecords = sort ? sortByDate(newRecords, 'StartDate') : sortAlphabetical(newRecords, 'Association')
    associationsList = associationsList.find(item => capitalize(item.label) === capitalize(meetingInfo.Association))
      ? associationsList
      : [...associationsList,
        { label: capitalize(meetingInfo.Association), value: capitalize(meetingInfo.Association) }
      ]
    return {
      ...state,
      renderData: {
        ...state.renderData,
        meetingRecords: newRecords,
        allAssociations: associationsList
      }
    }
  },
  [UPDATE_MEETING_RECORD_START] : (state) => {
    return {
      ...state
    }
  },
  [UPDATE_MEETING_RECORD_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [UPDATE_MEETING_RECORD_SUCCESS] : (state, action) => {
    const { meetingInfo } = action
    let associationsList = state.renderData.allAssociations
    const meetingRecords = state.renderData.meetingRecords.map(item => {
      if (item.Id === meetingInfo.Id) {
        return meetingInfo
      } else return item
    })
    associationsList = associationsList.find(item => capitalize(item.label) === capitalize(meetingInfo.Association))
      ? associationsList
      : [...associationsList,
        { label: capitalize(meetingInfo.Association), value: capitalize(meetingInfo.Association) }
      ]
    return {
      ...state,
      renderData: {
        ...state.renderData,
        meetingRecords,
        allAssociations: associationsList
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {
    sortApplied: true
  },
  formDataValue: {
    MD: {
      queryLine: {
        radio: {
          query: 0,
          sort: 'date'
        }
      },
      meetingModal: {
        textValues: {
          association: '',
          meeting: '',
          website: '',
          contact: '',
          location: ''
        },
        dateTime: {
          startDate: ' ',
          endDate: ' '
        }
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: {}
      }
    }
  }
}

export default function meetingDatesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/meetingDates.js